import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FileUploadListRoutingModule } from './file-upload-list-routing.module';
import { FileUploadListModalService } from './file-upload-list.service';
import { ModalModule } from 'ngx-bootstrap/modal';

import { FileUploadListComponent } from './file-upload-list.component';
import { FileUploadListModalComponent } from './file-upload-list-modal.component';
import { FileUploadListFileRowModule } from './file-row/index';


@NgModule({
  declarations: [
    FileUploadListModalComponent,
    FileUploadListComponent,
  ],
  imports: [
    CommonModule, FileUploadListFileRowModule,

    FileUploadListRoutingModule,
    ModalModule.forRoot(),
  ],
  providers:[FileUploadListModalService],
  entryComponents:[FileUploadListModalComponent],
})
export class FileUploadListModalModule { }
